module.exports = __webpack_public_path__ + "img/credit_debit_logo.3dca97ac.jpg";